import {
  Component,
  OnInit,
  OnDestroy,
  HostListener,
  Input,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { Meta, MetaDefinition, Title } from '@angular/platform-browser';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { environment } from '../../../environments/environment';
import { DeviceDetectorService } from 'ngx-device-detector';
// import * as $ from 'jquery';
import { AppService } from 'src/app/services/app.service';
import { min } from 'rxjs/operators';
import { NgForm } from '@angular/forms';
import { formatDate } from '@angular/common';

declare var $: any;
declare var UIkit: any;

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css'],
})
export class ProductComponent implements OnInit, OnDestroy {
  public product;
  @ViewChild('enquiryForm') enquiryForm: NgForm;

  public productEvents;
  public productEventsAvailable;
  public productEventsForDateAndTime;
  public calculatedPrice = 0;

  public responseReceived = false;
  public relatedProductsReceived;
  public relatedProducts;
  public pageSlug;
  public pageURL;
  public pageCity;
  public pageFeaturedImage;
  public productSpliceImages;
  public isMobile;
  public isDesktopDevice;
  public isTablet;
  public isSafari;
  public deviceInfo;
  public accessToken;
  public enquiryPayLoad = {
    full_name: '',
    email: '',
    mobile_number: '',
    occasion: 'Yes',
    occasion_date: '',
    product_id: '',
    number_of_guest: 0,
  };
  public minDate;
  public maxDate;

  // enquiry api
  public enquiryResponseAwaited = false;
  public enquiryResponseReceived = false;
  public enquiryErrorMessage = '';
  public enquirySuccessful = false;
  public NoOfGuests = [];
  public checkoutError = '';
  public availabilityPresent = true;
  public dateFilter: any;

  //taking media width in variable
  mobileMedia: any = window.matchMedia('(max-width:767px)');
  toggleClass: boolean = false;

  // order schedule
  public productSchedule = {
    date: null,
    ppl: '0',
    rowid: '',
    time_from: '',
    time_to: '',
    price: '',
    time: '0',
    event_price: '',
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private spinner: NgxSpinnerService,
    private loadingBar: LoadingBarService,
    private router: Router,
    private activatedRoue: ActivatedRoute,
    private metaService: Meta,
    private titleService: Title,
    protected $gaService: GoogleAnalyticsService,
    private deviceService: DeviceDetectorService,
    private appService: AppService
  ) {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.isMobile = this.deviceService.isMobile();
    this.isDesktopDevice = this.deviceService.isDesktop();
    this.isTablet = this.deviceService.isDesktop();
    this.isSafari = this.deviceService.browser === 'Safari' ? true : false;

    this.minDate = new Date();
    this.maxDate = new Date();
    this.minDate.setDate(this.minDate.getDate() + 3);
    this.maxDate.setDate(this.maxDate.getDate() + 90);

    this.appService.userLoggedIn.subscribe((data) => {
      this.accessToken = localStorage.getItem('accessToken');
    });

    this.appService.userLoggedOut.subscribe((data) => {
      this.accessToken = '';
    });
  }

  openSlideShow(): void {
    UIkit.lightbox('.mob-sli').show(0);
  }

  spliceIntoChunks(arr, chunkSize): any {
    const res = [];
    while (arr.length > 0) {
      const chunk = arr.splice(0, chunkSize);
      res.push(chunk);
    }
    return res;
  }

  ngOnInit(): void {
    this.accessToken = localStorage.getItem('accessToken');

    this.activatedRoute.params.subscribe((params) => {
      this.pageSlug = params.slug;
      this.pageCity = params.city;
      this.getProductDetails();

      setTimeout(() => {
        this.getRelatedProducts();
      }, 1000);
    });

    this.pageURL = 'https://things2.do' + this.router.url;

    $('.header-wrp').addClass('nav-down text-gray');
    $('.middle-panel').removeClass('scrolltoshow');
    $('.logo-box').removeClass('scrolltoshow');
    $('.location-dropdown').removeClass('scrolltoshow');
    $('.welcome-user').find('img').addClass('brigtness-black');
  }

  toggleAccordion(e): void {
    $(e).toggleClass('active');
  }

  ngOnDestroy(): void {
    $('video').remove();
  }

  fillTime(e): void {
    const time = formatDate(e.value, 'Y-MM-dd', 'en-us');
    console.log('time', time);

    this.calculatedPrice = 0;
    this.productSchedule.date = time;
    if (this.productEvents[this.productSchedule.date]?.length === 1) {
      this.productSchedule.time =
        this.productEvents[this.productSchedule.date][0].time_from +
        '-' +
        this.productEvents[this.productSchedule.date][0].time_to;
    }

    if (
      !this.productEvents[this.productSchedule.date] ||
      this.productEvents[this.productSchedule.date].length === 0 ||
      this.productSchedule.time.length === 0
    ) {
      this.availabilityPresent = false;
    } else {
      this.availabilityPresent = true;
    }

    this.fillGuests();
  }

  fillGuests(): void {
    this.calculatedPrice = 0;
    let time_range = this.productSchedule.time.split('-');

    this.productSchedule.time_from = time_range[0];
    this.productSchedule.time_to = time_range[1];

    this.productEventsForDateAndTime = Object.assign({}, this.productEvents);
    this.productEventsForDateAndTime = this.productEventsForDateAndTime[
      this.productSchedule.date
    ].filter((x) => x.time_from == this.productSchedule.time_from);

    this.NoOfGuests = [];
    this.NoOfGuests = [
      ...new Set(this.productEventsForDateAndTime.map((item) => item.ppl)),
    ];

    if (this.NoOfGuests.length === 1) {
      this.productSchedule.ppl = this.NoOfGuests[0];
    }

    this.setPrice();
  }

  setPrice(): void {
    this.productEventsForDateAndTime.forEach((item) => {
      if (this.productSchedule.ppl == item.ppl) {
        this.calculatedPrice = item.price;
        this.productSchedule.price = this.calculatedPrice.toString();
        this.productSchedule.event_price = this.calculatedPrice.toString();
        return;
      }
    });
  }

  /**
   * Add this product to the cart
   */
  addToCart(): boolean {
    if (
      this.product.details.product_type !== 'STANDARD' &&
      this.isDesktopDevice
    ) {
      if (
        !this.productSchedule.date ||
        this.productSchedule.date === '' ||
        this.productSchedule.date === 0
      ) {
        this.checkoutError = 'Please select the date and time slot. ';
        return false;
      }
    }
    // add to cart
    localStorage.setItem('schedule', JSON.stringify(this.productSchedule));
    localStorage.setItem('product', JSON.stringify(this.product));
    this.router.navigate(['/order-summary']);
  }

  /**
   * Get the availability details for the current product.
   */
  getProductAvailability(): void {
    this.loadingBar.start();
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };

    this.http
      .post<any>(
        environment.domain + '/api/' + this.pageCity + '/product-event',
        { slug: this.pageSlug },
        httpOptions
      )
      .subscribe(
        (data) => {
          this.loadingBar.stop();
          this.productEvents = data.event_date;
          this.productEventsAvailable = true;

          const availableDates = [];

          for (var key in this.productEvents) {
            availableDates.push(key);
          }

          // disable the dates not present.
          this.dateFilter = (d: Date | null): boolean => {
            const time = formatDate(d.getTime(), 'Y-MM-dd', 'en-us');
            return availableDates.find((x) => x == time);
          };
        },
        (error) => {
          this.loadingBar.stop();
          console.error('There was an error!', error);
        }
      );
  }

  getProductDetails(): void {
    this.loadingBar.start();
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };

    this.http
      .post<any>(
        environment.domain + '/api/' + this.pageCity + '/product-details',
        {
          slug: this.pageSlug,
          city: this.appService.getCurrentCity(),
        },
        httpOptions
      )
      .subscribe(
        (data) => {
          this.loadingBar.stop();
          this.product = data.products;

          this.appService.updateMeta(this.pageSlug, this.product);

          this.enquiryPayLoad.product_id = this.product.details.id;
          const productImages = Object.assign([], this.product.product_images);
          this.productSpliceImages = this.spliceIntoChunks(productImages, 2);

          this.product.product_images.forEach((element) => {
            this.pageFeaturedImage = element.images;
          });

          this.responseReceived = true;
          //this.updateMeta();
          this.getProductAvailability();
        },
        (error) => {
          this.loadingBar.stop();
          console.error('There was an error!', error);
        }
      );
  }

  getRelatedProducts(): void {
    this.loadingBar.start();
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };

    const params = { exclude: this.product.details.id };

    this.http
      .get<any>(
        environment.domain +
          '/api/EXPERIENCE/related-products/' +
          this.product.details.id,
        httpOptions
      )
      .subscribe(
        (data) => {
          this.relatedProductsReceived = true;
          this.loadingBar.stop();
          this.relatedProducts = data.related_product;
        },
        (error) => {
          console.error('There was an error!', error);
          this.loadingBar.stop();
        }
      );
  }

  ShowProductDetail(product): void {
    this.router.navigate(
      ['c/' + product.details.city.toLowerCase() + '/' + product.details.slug],
      { state: product }
    );
  }

  expandList(e): void {
    if (e.innerHTML.includes('more')) {
      $('.ShowList').show();
      e.innerHTML = 'Show less';
    } else {
      $('.ShowList').hide();
      e.innerHTML = 'Show more';
    }
  }

  playVideo(e): void {
    if (e.paused) {
      e.play();
    } else {
      e.pause();
    }
  }

  playVideoByID(el: any, button: any): void {
    if (this.isMobile) {
      return;
    }

    const e = $('#' + el)[0];
    $('#' + button).hide();

    if (e === undefined || e.paused === undefined || e.paused) {
      e.play();
    } else {
      e.pause();
    }
  }

  pauseVideo(e): void {
    e.pause();
  }

  openShareLink(): void {
    $('.sharelink').slideToggle();
  }

  submitEnquiry(): void {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };

    if (this.enquiryForm.valid) {
      this.enquiryResponseAwaited = true;
      this.http
        .post<any>(
          environment.domain + '/api/product-enquiry',
          this.enquiryPayLoad,
          httpOptions
        )
        .subscribe(
          (data) => {
            this.enquiryResponseReceived = true;
            this.enquiryResponseAwaited = false;

            if (data.type === 'success') {
              this.enquirySuccessful = true;
            } else {
              this.enquirySuccessful = true;
              this.enquiryErrorMessage = 'Some error occurred';
            }
          },
          (error) => {
            console.error('There was an error!', error);
            this.enquiryResponseAwaited = false;
            this.enquiryErrorMessage = 'Some error occurred.' + error;
          }
        );
    }
  }
}
